import { useTranslation } from 'react-i18next';
import type { MergeTask } from './queries';

export function Progress({ tasks }: { tasks: MergeTask[] }) {
  const { t } = useTranslation(['jobs', 'common']);
  const total = tasks.length;
  const done = tasks.filter((task) => task.status === 'verified' || task.status === 'merged').length;
  const skipped = tasks.filter((task) => task.status === 'skipped_stale').length;
  const failed = tasks.filter((task) => task.status === 'failed').length;
  const pct = (n: number) => (total > 0 ? (n / total) * 100 : 0);
  return (
    <div>
      <div
        className="bo-progress"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={done + skipped + failed}
        aria-label={t('progress.aria')}
      >
        <span className="bo-progress__done" style={{ width: `${pct(done)}%` }} />
        <span className="bo-progress__skipped" style={{ width: `${pct(skipped)}%` }} />
        <span className="bo-progress__failed" style={{ width: `${pct(failed)}%` }} />
      </div>
      <p className="bo-legend">
        <span>
          <strong>{done}</strong> {t('progress.merged')}
        </span>
        <span>
          <strong>{skipped}</strong> {t('progress.skipped')}
        </span>
        <span className={failed > 0 ? 'bo-legend__failed' : undefined}>
          <strong>{failed}</strong> {t('progress.failed')}
        </span>
        <span>
          <strong>{total}</strong> {t('progress.tasks', { count: total })}
        </span>
      </p>
    </div>
  );
}
